'use client';
import { useState } from 'react';
import { PlusIcon, MinusIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export function ExpandingCard({
  title,
  icon,
  children,
  defaultOpen = false,
  iconColor,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  iconColor?: string;
}) {
  const [expanded, setExpanded] = useState(defaultOpen ?? false);
  const toggleExpanded = () => setExpanded(prev => !prev);

  return (
    <div className="flex flex-col rounded-2xl border border-[#2E3135] bg-[#202328] p-6">
      <button onClick={toggleExpanded} className="flex w-full items-center gap-[0.625rem]">
        <div className={`hidden h-fit rounded-lg ${iconColor} p-[0.625rem] md:block`}>{icon}</div>
        <h4 className="text-h6 mr-auto flex items-center gap-2 text-white">{title}</h4>
        {expanded ? <MinusIcon className="size-6 text-white" /> : <PlusIcon className="size-6 text-white" />}
      </button>
      <div
        className={clsx(
          'ml-0 overflow-scroll transition-all duration-500 ease-in-out md:ml-14',
          expanded ? 'max-h-96' : 'max-h-0',
        )}
      >
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
}
